import React, { useState, useRef } from "react";
import { useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap";
import DatePicker from "react-widgets/DatePicker";
import moment from "moment";

import Constants from "../../common/Constants";
import { validateReportDateRange } from "./util";

const FilterBox = (props) => {
  const { t } = useTranslation();
  const formRef = useRef(null);
  const [optionValue, setOptionValue] = useState("Custom");
  const [requiredFrom, setRequiredFrom] = useState();
  const [requiredTo, setRequiredTo] = useState();
  const [operatorUserId, setOperatorUserId] = useState("");

  let filterDayLimit = useSelector((state) => state?.common?.data?.filterDaysLimit); // User Details from Store

  const handleCancel = () => {
    setRequiredTo("");
    setRequiredFrom("");
    setOptionValue("");
    props.resetFilerBox(false);
    props.resetSearch();
  };

  const handleSearch = () => {
    if (!validateReportDateRange(requiredFrom, requiredTo, filterDayLimit)) {
      return;
    }

    const filterObj = {
      requiredFrom,
      requiredTo,
    };
    if (props.operatorFilter) {
      filterObj.operatorUserId = operatorUserId
    }
    props.searchData(filterObj);
  };

  const handleDownload = () => {
    if (!validateReportDateRange(requiredFrom, requiredTo, filterDayLimit)) {
      return;
    }

    const filterObj = {
      requiredFrom,
      requiredTo,
      download: true,
    };
    if (props.operatorFilter) {
      filterObj.operatorUserId = operatorUserId
    }
    props.handleDownload(filterObj);
  };

  return (
    <Form noValidate ref={formRef}>
      <Row className="mx-3" xs={12} md={12} lg={12}>
        <>
          <Col className="mx-3" sm={5} md={2} lg={2}>
            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
              <Form.Label className="">
                {t("msg_common.select_filter_option")} :
              </Form.Label>
              <Form.Select
                aria-label="select filter"
                size="md"
                value={optionValue}
                onChange={(e) => setOptionValue(e.target.value)}
              >
                <option value="Custom">{t("msg_common.custom")}</option>
                {/* <option value="Month">{t("msg_common.month")}</option>
                <option value="Year">{t("msg_common.year")}</option> */}
                {props.operatorFilter && <option value="OperatorId">{t("msg_common.operator")}</option>}
              </Form.Select>
            </Form.Group>
          </Col>
        </>
        {optionValue === "Custom" && (
          <>
            <Col className="mx-3" sm={5} md={2} lg={2}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>
                  {t("msg_trasaction.msg_generatejobcard.requiredFrom")}
                </Form.Label>
                <DatePicker
                  required
                  placeholder="From Date"
                  name="requiredFrom"
                  valueFormat={{ dateStyle: "medium" }}
                  onChange={(e) => {
                    const formattedDate = moment(e).isValid()
                      ? moment(e).format("YYYY-MM-DD")
                      : "";
                    setRequiredFrom(formattedDate);
                    validateReportDateRange(formattedDate, requiredTo, filterDayLimit);
                    //setRequiredFrom(moment(e).format('YYYY-MM-DD') || "")
                  }}
                  autoFocus
                />
              </Form.Group>
            </Col>
            <Col className="mx-3" sm={5} md={2} lg={2}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>
                  {t("msg_trasaction.msg_generatejobcard.requiredTo")}
                </Form.Label>
                <DatePicker
                  required
                  placeholder="To Date"
                  name="requiredTo"
                  valueFormat={{ dateStyle: "medium" }}
                  onChange={(e) => {
                    const formattedDate = moment(e).isValid()
                      ? moment(e).format("YYYY-MM-DD")
                      : "";
                    setRequiredTo(formattedDate);
                    validateReportDateRange(requiredFrom, formattedDate, filterDayLimit);
                    //setRequiredTo(moment(e).format("YYYY-MM-DD"));
                  }}
                  autoFocus
                />
              </Form.Group>
            </Col>
          </>
        )}
        {optionValue === "Month" && (
          <>
            <Col className="mx-3" sm={5} md={2} lg={2}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>
                  {t("msg_trasaction.msg_generatejobcard.requiredFrom")}
                </Form.Label>
                <DatePicker
                  required
                  max={new Date()}
                  placeholder="mm yyyy"
                  name="requiredFrom"
                  valueFormat={{ month: "short", year: "numeric" }}
                  calendarProps={{ views: ["year", "decade", "century"] }}
                  onChange={(e) => {
                    const formattedDate = moment(e).isValid()
                      ? moment(e).format("YYYY-MM-DD")
                      : "";
                    setRequiredFrom(formattedDate);
                    //setRequiredTo(moment(e).format("YYYY-MM-DD"));
                  }}
                  autoFocus
                />
              </Form.Group>
            </Col>
            <Col className="mx-3" sm={5} md={2} lg={2}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>
                  {t("msg_trasaction.msg_generatejobcard.requiredTo")}
                </Form.Label>
                <DatePicker
                  required
                  max={new Date()}
                  placeholder="mm yyyy"
                  name="requiredTo"
                  valueFormat={{ month: "short", year: "numeric" }}
                  calendarProps={{ views: ["year", "decade", "century"] }}
                  onChange={(e) => {
                    const y = e.getFullYear();
                    const m = e.getMonth();
                    const lastDate = new Date(y, m + 1, 0);
                    const formattedDate = moment(lastDate).isValid()
                      ? moment(lastDate).format("YYYY-MM-DD")
                      : "";
                    setRequiredTo(formattedDate);
                    //setRequiredFrom(moment(e).format('YYYY-MM-DD') || "")
                  }}
                  autoFocus
                />
              </Form.Group>
            </Col>
          </>
        )}
        {optionValue === "Year" && (
          <>
            <Col className="mx-3" sm={5} md={3} lg={3}>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>{t("msg_common.select_year")}</Form.Label>
                <DatePicker
                  required
                  max={new Date()}
                  placeholder="yyyy"
                  name="requiredFrom"
                  valueFormat={{ year: "numeric" }}
                  calendarProps={{ views: ["decade", "century"] }}
                  onChange={(e) => {
                    const lastDate = new Date(e.getFullYear(), 11, 31);
                    const formattedFromDate = moment(e).isValid()
                      ? moment(e).format("YYYY-MM-DD")
                      : "";
                    const formattedToDate = moment(lastDate).isValid()
                      ? moment(lastDate).format("YYYY-MM-DD")
                      : "";
                    setRequiredFrom(formattedFromDate);
                    setRequiredTo(formattedToDate);
                    //setRequiredFrom(moment(e).format('YYYY-MM-DD') || "")
                  }}
                  autoFocus
                />
              </Form.Group>
            </Col>
          </>
        )}
        {optionValue === "OperatorId" && (
          <>
            <Col className="mx-3" sm={12} md={8} lg={8}>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label >
                  {" "}
                  {t("msg_reports.msg_operator_report.operator_Id")} :
                </Form.Label>
                <Form.Control
                  type="text"
                  value={operatorUserId || ""}
                  placeholder="e.g: OPE-001"
                  onChange={(e) => setOperatorUserId(e.target.value)}
                  maxLength={Constants.MASTER.VALIDATION.maxLengthName}
                  required
                />
                <Form.Control.Feedback type="invalid">
                  {t("msg_master_list.msg_department.department_name_validation")}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </>
        )}
        <Col className="filterbox-btn " sm={6} md={5} lg={4}>
          <Button
            type="button"
            size="md"
            variant="primary"
            className="btn btn-primary btn-xs"
            onClick={() => handleSearch()}
          >
            {t("msg_common.search")}
          </Button>

          <Button
            type="button"
            size="md"
            variant="danger"
            className="btn btn-primary btn-xs"
            onClick={() => handleCancel()}
          >
            {t("msg_common.cancel")}
          </Button>

          <Button
            type="button"
            size="md"
            variant="secondary"
            className="btn btn-primary btn-xs"
            onClick={() => handleDownload()}
          >
            <i className="bi bi-download"> </i>
            {"Export"}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default FilterBox;
